import React from 'react';
import { Container, Grid, GridItem } from '@fiverr-private/layout_components';
import { IconButton, TextButton } from '@fiverr-private/button';
import { ArrowLeftIcon, FiverrLogo } from '@fiverr-private/visuals';
import { theme } from '@fiverr-private/theme';
import pathfinder from '@fiverr-private/pathfinder';
import { useStepsContext } from '../StepsContext';
import { translate } from '../../shared/utils/translate';

export const OnboardingHeader = () => {
    const { hasBack, goBack } = useStepsContext();

    return (
        <Container
            borderBottomWidth="sm"
            borderColor="grey_500"
            backgroundColor="white"
            borderStyle="solid"
            width="100%"
            paddingX={{ default: '6', sm: '8', md: '10' }}
            paddingY="6"
        >
            <Grid
                hidden={{ default: true, sm: false }}
                alignItems="center"
                width="100%"
                margin="auto"
                templateColumns="50%_50%"
            >
                <GridItem padding="2" display="flex" justifyContent="flexStart" alignItems="center">
                    <FiverrLogo size="sm" />
                </GridItem>
                <GridItem display="flex" justifyContent="flexEnd" alignItems="center">
                    <TextButton href={pathfinder('homepage')}>{translate('onboarding_flow.exit')}</TextButton>
                </GridItem>
            </Grid>

            <Grid
                hidden={{ default: false, sm: true }}
                maxWidth={theme.numericBreakpoints.xl}
                width="100%"
                margin="auto"
                templateColumns="33%_33%_33%"
                alignItems="center"
            >
                <GridItem alignItems="center">
                    {hasBack && (
                        <IconButton aria-label={translate('general.back')} size="sm" variant="ghost" onClick={goBack}>
                            <ArrowLeftIcon size="sm" />
                        </IconButton>
                    )}
                </GridItem>
                <GridItem
                    padding={{ default: '0', sm: '2' }}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                >
                    <FiverrLogo size="sm" />
                </GridItem>
                <GridItem display="flex" justifyContent="flexEnd" alignItems="center">
                    <TextButton href={pathfinder('homepage')} size={{ default: 'sm', sm: 'md' }}>
                        {translate('onboarding_flow.exit')}
                    </TextButton>
                </GridItem>
            </Grid>
        </Container>
    );
};
